module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/eat-drinks/eat-and-drinks.png";